const tables = document.querySelectorAll('.iww-table-scroll');

tables.forEach(table => {
    const container = table.closest('.iww-container-table-scroll');
    if (table.offsetWidth > container.offsetWidth) {
        container.classList.add('after:block');
        container.classList.remove('after:hidden');
        table.classList.add('mr-6');
    }
    else {
        container.classList.add('after:hidden');
        container.classList.remove('after:block');
        table.classList.remove('mr-6');
    }

});
